module.exports = __webpack_public_path__ + "img/right.735495e6.svg";